import { User } from '@/api/_schemas/users'
import { getCurrentUser } from '@/api/users'
import { queryClient } from '@/config/query-client'
import { setTokens } from '@/services/token-storage'

type LoginResponse = {
  authenticated: boolean | null
  profile: User | null
  isLoading: boolean
}

type LoginParams = {
  tokenBf: string | null
  tokenAgp: string | null
}

type AuthService = {
  login: (params: LoginParams) => Promise<LoginResponse>
  logout: (removeAccessToken: () => void) => Promise<LoginResponse>
}

const authService: AuthService = {
  login: async ({ tokenAgp, tokenBf }) => {
    setTokens({ tokenAgp, tokenBf })
    const hasTokens = !!tokenAgp && !!tokenBf

    const profile = hasTokens ? await getCurrentUser().catch(() => null) : null

    return {
      authenticated: hasTokens && !!profile,
      profile,
      isLoading: false,
    }
  },
  logout: async (removeAccessTokens) => {
    queryClient.clear()
    removeAccessTokens()

    return {
      authenticated: false,
      profile: null,
      isLoading: false,
    }
  },
}

export { authService, type LoginParams }
